<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-end justify-between">
            <div data-cy="company-settings-templates-title">{{ $t('company.templates.title') }}</div>
        </div>
        <table-templates ref="TableTemplates" :company_id="company_id" @onTableAction="onTableAction" @onAdd="onAdd" />
        <a-drawer
            data-cy="template_drawer"
            :title="$t('template.general.drawer.title')"
            :width="500"
            :open="drawer_visible"
            :body-style="{ padding: '0px', paddingBottom: '10px' }"
            :destroyOnClose="true"
            :maskClosable="false"
            @close="onClose"
        >
            <form-template
                data-cy="template-form"
                ref="TemplateForm"
                :template="template"
                :processing="processing"
                :validation="validation"
                @is-form-dirty="isDrawerFormDirty"
                @formSubmit="onSave"
                @onDrawerClose="onClose"
            >
            </form-template>
        </a-drawer>
    </div>
</template>

<script>
import TableTemplates from '@/components/tables/Templates.vue';
import FormTemplate from '@/components/forms/Template.vue';

export default {
    components: {
        TableTemplates,
        FormTemplate,
    },
    data() {
        return {
            template: {},
            drawer_visible: false,
            drawer_form_dirty: false,
            validation: {
                errors: {},
                message: '',
            },
            processing: false,
        };
    },
    props: {
        company_id: {
            type: String,
            default: '',
        },
    },
    methods: {
        onAdd() {
            this.openDrawer('');
        },
        onTableAction(data) {
            switch (data.key) {
                case 'create':
                    this.openDrawer('');
                    break;
                case 'edit':
                    this.openDrawer(data.id);
                    break;
            }
        },
        openDrawer(id) {
            if (id != '') {
                this.$http.get('/api/templates/' + id).then((response) => {
                    let template_data = {
                        ...response.data.data,
                    };
                    this.template = template_data;

                    this.validation = {
                        errors: {},
                        message: '',
                    };
                    this.drawer_visible = true;
                });
            } else {
                this.template = {
                    certificate_code: '',
                    certificate_type: '',
                    section_1_label: '',
                    section_1: '',
                    section_2_label: '',
                    section_2: '',
                    section_3_label: '',
                    section_3: '',
                    section_4_label: '',
                    section_4: '',
                };
                this.validation = {
                    errors: {},
                    message: '',
                };
                this.drawer_visible = true;
            }
        },
        isDrawerFormDirty(is_dirty) {
            this.drawer_form_dirty = is_dirty;
        },
        onClose() {
            this.drawer_form_dirty = false;
            this.drawer_visible = false;
        },
        onSave() {
            if (this.processing) {
                return false;
            }

            this.drawer_form_dirty = false;
            this.processing = true;

            let id = this.template.id;

            let params = {
                ...this.template,
                company_id: this.company_id,
                section_1: this.encodeValue(this.template.section_1),
                section_2: this.encodeValue(this.template.section_2),
                section_3: this.encodeValue(this.template.section_3),
                section_4: this.encodeValue(this.template.section_4),
            };

            if (id == undefined) {
                this.$http
                    .post('/api/templates', params)
                    .then((response) => {
                        if (response.data.status == 'success') {
                            this.drawer_form_dirty = false;

                            this.$refs.TableTemplates.reload();

                            this.drawer_visible = false;
                        } else {
                            this.$notification.error({
                                message: response.data.message,
                            });
                        }
                    })
                    .catch((error) => {
                        if (error.response.status == 422) {
                            this.validation = error.response.data;
                        } else if (error.response.status == 403) {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.403_mod'),
                            });
                        } else {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVCA0133' }),
                            });
                        }
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            } else {
                this.$http
                    .post('/api/templates/' + id + '/update', params)
                    .then((response) => {
                        this.drawer_form_dirty = false;
                        this.$refs.TableTemplates.reload();
                        this.drawer_visible = false;
                    })
                    .catch((error) => {
                        if (error.response.status == 422) {
                            this.$notification.error({
                                message: error.response.data.message,
                            });

                            this.validation = error.response.data;
                        } else if (error.response.status == 403) {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.403_mod'),
                            });
                        } else {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVUU07' }),
                            });
                        }
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            }
        },
        encodeValue(value) {
            // Encode the value before sending
            return _.isEmpty(value) ? '' : value.replace(/</g, '__obkrt__').replace(/>/g, '__cbkrt__');
        },
        reload() {
            this.$refs.TableTemplates.reload();
        },
    },
};
</script>
